import { render, staticRenderFns } from "./ClientDemographicsProfile.vue?vue&type=template&id=5476d3a8"
import script from "./ClientDemographicsProfile.vue?vue&type=script&lang=js"
export * from "./ClientDemographicsProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports